import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {
    SIGNIN_USER,
    SIGNOUT_USER} from "constants/ActionTypes";
import {showAuthMessage, userSignInSuccess, userSignOutSuccess} from "actions/auth.action";
import qs from 'qs'
import { authInstanceWithoutHeaders } from "sagas";


const signInUserWithEmailPasswordRequest = async (email, password) => {

    return authInstanceWithoutHeaders({
        method: 'post',
        url: 'api/v1/public/auth/login',
        data: qs.stringify({
            'email': email,
            'password': password,
            'grant_type':"password"
        })
      })
}
   /* await  auth.signInWithEmailAndPassword(email, password)
        .then(authUser => authUser)
        .catch(error => error);*/

const signOutRequest = async () => {

}
    /*await  auth.signOut()
        .then(authUser => authUser)
        .catch(error => error);*/


function* signInUserWithEmailPassword({payload}) {
    const {email, password} = payload;
    try {
        const signInUser = yield call(signInUserWithEmailPasswordRequest, email, password);
        if (signInUser.data.success) {
            localStorage.setItem('user', JSON.stringify(signInUser));
            yield put(userSignInSuccess(signInUser.data));
        } else {
            yield put(showAuthMessage(signInUser.data.message));
        }
    } catch (error) {
        let errorMessage = "Something went wrong. Please try again later!";
        if (error.response != null && error.response.data!=null&&error.response.data.message!=null){
            errorMessage = error.response.data.message;
        }
        yield put(showAuthMessage(errorMessage)); // error payload should set to string
    }
}

function* signOut() {
    try {
        const signOutUser = yield call(signOutRequest);
        if (signOutUser === undefined) {
            localStorage.removeItem('user');
            yield put(userSignOutSuccess(signOutUser));
        } else {
            yield put(showAuthMessage(signOutUser.message));
        }
    } catch (error) {
        yield put(showAuthMessage(error));
    }
}

export function* signInUser() {
    yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
    yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
    yield all([
        fork(signInUser),
        fork(signOutUser)
    ]);
}
